import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PropTypes from 'prop-types';
import logger from '../utils/logger';

// Componente para proteger rutas que requieren autenticación
const PrivateRoute = ({ requiredRoles = [] }) => {
  const { isAuthenticated, user, loading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '15px',
          padding: '40px',
          background: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #061156',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p>Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  // Verificar si el usuario está autenticado
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Si se requieren roles específicos, verificar si el usuario tiene alguno de ellos
  if (requiredRoles.length > 0) {
    // Verificar si el usuario tiene un rol definido
    if (!user || !user.role) {
      logger.error('Usuario sin rol definido:', { user });
      return <Navigate to="/unauthorized" replace />;
    }

    // Verificar si el usuario tiene alguno de los roles requeridos
    if (!requiredRoles.includes(user.role)) {
      logger.error('Usuario sin permisos', {
        rolActual: user.role,
        rolesRequeridos: requiredRoles,
      });
      return <Navigate to="/unauthorized" replace />;
    }

    logger.info('Usuario autorizado', {
      rolActual: user.role,
      rolesRequeridos: requiredRoles,
    });
  } else {
    // Si no se requieren roles específicos, cualquier usuario autenticado puede acceder
    logger.debug('Ruta sin roles requeridos. Acceso permitido para cualquier usuario autenticado.');
  }

  // Si el usuario está autenticado y tiene los roles requeridos, mostrar el contenido
  return <Outlet />;
};

// Definición de PropTypes
PrivateRoute.propTypes = {
  // Array de roles requeridos para acceder a la ruta
  requiredRoles: PropTypes.arrayOf(PropTypes.string),
};

export default PrivateRoute;
